import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
} from '@angular/core';
import { PalantirSelectItemOverlayService } from './select-item-overlay.service';
import type { PalantirSelectItemOverlayOptions } from './select-item-overlay.type';

@Directive({
  selector: '[palantirSelectItemOverlay]',
  exportAs: 'palantirSelectItemOverlay',
  standalone: true,
})
export class PalantirSelectItemOverlayDirective {
  @Input() public palantirSelectItemOverlay!: PalantirSelectItemOverlayOptions<any>;

  @Output() public selectionChange = new EventEmitter<any[]>();

  private readonly overlayService = inject(PalantirSelectItemOverlayService);

  private readonly elementRef = inject(ElementRef<HTMLElement>);

  @HostListener('click', ['$event'])
  public async onClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const { data } = await this.overlayService.open(
      this.elementRef,
      this.palantirSelectItemOverlay,
    );
    this.selectionChange.emit(data);
  }
}
